<template>

    <section class="dd-l-section--quiz"
             v-if="data"
             v-bind:style="{'background-image' : data.background ? 'url('+data.background+')' : ''}">

        <div class="dd-m-quiz__container">
            <header class="dd-m-quiz__container__header">
                <button @click.prevent="closeOfflineQuiz"
                        class="dd-m-button dd-m-button--auto dd-m-button--assertive dd-m-button--circled">
                    <i class="icon-close"></i>
                </button>
            </header>

            <div v-if="step !== 2 && step !== 4" class="dd-m-quiz__thumb">
                <picture class="dd-m-quiz__img">
                    <source :srcset="data.image.desktop" media="(min-width: 1280px)">
                    <source :srcset="data.image.tablet" media="(min-width: 768px)">
                    <img :srcset="data.image.mobile" :alt="data.title">
                </picture>

                <quiz-loading v-if="step != 1"></quiz-loading>
            </div>

            <div class="dd-m-quiz__content" v-bind:class="{ 'has-padding' : step !== 2 && step !== 4 }">

                <!-- Step 1 -->
                <div v-if="step == 1" class="dd-m-quiz__step">
                    <h1 class="dd-m-quiz__title">
                        {{data.description}}
                    </h1>

                    <button v-on:click.prevent="changeStep(2)" type="button"
                            class="dd-btn-init-quiz dd-m-button dd-m-button--default dd-m-button--assertive">
                        Start Quiz
                    </button>
                </div>

                <!-- Step 2 -->
                <div v-if="step == 2" class="dd-m-quiz__step">
                    <quiz-questions-list
                            :questions="data.questions"
                            :offline="true"
                            :id="data.id"></quiz-questions-list>
                </div>

                <!-- Step 3 -->
                <div v-if="step == 3" class="dd-m-quiz__step">
                    <h1 class="dd-m-quiz__title dd-m-quiz__title--custom">
                        Congratulations! We will load your results in a second!
                    </h1>
                </div>

                <!-- Step 4 -->
                <div v-if="step == 4" class="dd-m-quiz__step">
                    <needscope-result :offline="true" :needscope="needscope"></needscope-result>
                </div>
            </div>
        </div>

    </section>

</template>
<script>
    import QuizQuestionsList from "./quiz-questions-list";
    import NeedscopeResult from "./needscope-result";
    import QuizLoading from "./quiz-loading";

    /**
     * 1 = init
     * 2 = questions list
     * 3 = loading
     * 4 = quiz completed
     */

    export default {
        name: 'quiz-content',
        components: {QuizLoading, NeedscopeResult, QuizQuestionsList},
        props: ['data'],
        data: () => {
            return {
                step: 1,
                results: [],
                needscope: null,
                hasQuiz: null
            }
        },
        mounted() {
            PubSub.subscribe('updateQuizStep', (msg, data) => {
                this.changeStep(data.step);
                this.needscope = data.needscope;
            });
            this.getQuiz();
        },
        methods: {
            getQuiz() {
                if (this.data) {
                    this.data.questions.map((item, i) => {
                        item.id = i;
                    });

                    this.updateQuizCount();
                } else {
                    this.hasQuiz = false;
                }
            },
            changeStep(newStep) {
                this.step = newStep;
            },
            updateQuizCount() {
                const hasAccessedOnceAQuiz = localStorage.hasAccessedOnceAQuiz;
                if (!hasAccessedOnceAQuiz) {
                    localStorage.hasAccessedOnceAQuiz = 1;
                }
            },
            closeOfflineQuiz() {
                PubSub.publish('closeOfflineQuizModal');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/quiz/quiz-content-offline.vue